import ElementBuilder from './utils'

const elementBuilder = ElementBuilder
    .forService('Logger',ElementBuilder.idPrefix+'logger','#{logger}')
    .addIcon("https://raw.githubusercontent.com/twbs/icons/main/icons/journal.svg")
    .addInputParam("loggerName","Logger Name","Specify name for the logger, leave empy for Default")
    .addInputParam("level","Log Level","error,warn,info,debug","info")
    .addInputParam("message","Log Message","What to log","info")

export default elementBuilder.element